
<template>
  <div>
    <dialog-edit-company-users></dialog-edit-company-users>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import DialogEditCompanyUsers from '../../../components/admin/company/DialogEditCompanyUsers.vue'
//import validations from '@/mixins/validations'
//import Api from '@/api/index';

export default {
  name: 'ShowCompanyUsersPage',
  //mixins: [ validations ],
  components: {
    DialogEditCompanyUsers
    //ComponentName: () => import(''),
  },
  data() {
    return {
    }
  },
  methods: {
    name() {
      
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style scoped>

</style>